var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-upload",
        {
          attrs: {
            "list-type": "picture-card",
            "file-list": _vm.fileList,
            customRequest: _vm.handleFileUpload,
            "before-upload": _vm.beforeFileUpload,
            disabled: _vm.disabled || _vm.uploading,
            remove: _vm.handleRemove,
            accept: _vm.accept
          },
          on: { preview: _vm.preview }
        },
        [
          _vm.uploading ? _c("a-spin") : _vm._e(),
          _vm._v(" "),
          _vm.fileList.length < _vm.num && !_vm.uploading
            ? _c("div", [
                _c(
                  "svg",
                  {
                    staticClass: "icon img-icon",
                    attrs: { "aria-hidden": "true" }
                  },
                  [
                    _c("use", {
                      attrs: { "xlink:href": "#gold-icon-shangchuan" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ant-upload-text",
                    staticStyle: { color: "#1990FF" }
                  },
                  [_vm._v(_vm._s(_vm.text))]
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("imgView", {
        ref: "imgView",
        attrs: { src: _vm.viewSrc },
        on: {
          "update:src": function($event) {
            _vm.viewSrc = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-315b6164", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-315b6164","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/img-upload/img-upload.vue
// module id = g9/C
// module chunks = 1